import gql from 'graphql-tag'
export default gql`
  query viewerQuery($token: String!) {
    viewer(token: $token) {
      id
      changePassword
      username
    }
  }
`
